import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)/onboarding/complete')({
  component: () => <Navigate to='/onboarding' />,
})
